import React from "react";
interface OrderIdLinkProps {
  orderId: string;
  inventoryUrl: string;
}

export const OrderIdLink: React.FC<OrderIdLinkProps> = ({ inventoryUrl, orderId }) => {
  return (
    <a href={`${inventoryUrl}/order-transactions/${orderId}`} className="t-order-id" target="_blank">
      {orderId}
    </a>
  );
};
